// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rUtWBR2XI0ZgpczG0Uhf {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 37rem;
    min-height: 500px;
    padding: 3rem 6.5rem;
    background-color: var(--color-primary-white);
    margin: 0 auto 1.5rem;
    border-radius: 16px;
    box-shadow: 0 20px 24px -4px rgba(0, 0, 0, 0.08), 2px -8px 8px -4px rgba(0, 0, 0, 0.03);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (1px <= width <= 768px) {
        padding: 3rem 1rem 1.5rem;
        margin-bottom: 0;
        min-height: 400px;
    }
}

.YsV7mG2_YsTGyxqkijSJ {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    min-width: 24px;
    height: auto;
}

.G1fUvIBWsGAOQXEiH8gS {
    font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/Card.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,4CAA4C;IAC5C,qBAAqB;IACrB,mBAAmB;IACnB,uFAAuF;IACvF,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;;IAE9B;QACI,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".card {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    max-width: 37rem;\n    min-height: 500px;\n    padding: 3rem 6.5rem;\n    background-color: var(--color-primary-white);\n    margin: 0 auto 1.5rem;\n    border-radius: 16px;\n    box-shadow: 0 20px 24px -4px rgba(0, 0, 0, 0.08), 2px -8px 8px -4px rgba(0, 0, 0, 0.03);\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    @media (1px <= width <= 768px) {\n        padding: 3rem 1rem 1.5rem;\n        margin-bottom: 0;\n        min-height: 400px;\n    }\n}\n\n.link {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 24px;\n    min-width: 24px;\n    height: auto;\n}\n\n.footer-title {\n    font-size: 0.875rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `rUtWBR2XI0ZgpczG0Uhf`,
	"link": `YsV7mG2_YsTGyxqkijSJ`,
	"footerTitle": `G1fUvIBWsGAOQXEiH8gS`
};
module.exports = ___CSS_LOADER_EXPORT___;
